// Suppress VideoJS deprecation warnings globally
const originalWarn = console.warn;
const originalError = console.error;

// Function to check if a message should be suppressed
const shouldSuppressVideoJSWarning = (message) => {
  if (typeof message !== 'string') return false;
  
  const videoJSWarnings = [
    'videojs.plugin() is deprecated',
    'videojs.mergeOptions is deprecated',
    'videojs.createEl() is deprecated',
    'VIDEOJS: WARN: videojs.plugin() is deprecated',
    'VIDEOJS: WARN: videojs.mergeOptions is deprecated',
    'VIDEOJS: WARN: videojs.createEl() is deprecated'
  ];
  
  return videoJSWarnings.some(warning => message.includes(warning));
};

// Override console.warn
console.warn = (...args) => {
  if (args[0] && shouldSuppressVideoJSWarning(args[0])) {
    return; // Suppress VideoJS deprecation warnings
  }
  originalWarn.apply(console, args);
};

// Override console.error
console.error = (...args) => {
  if (args[0] && shouldSuppressVideoJSWarning(args[0])) {
    return; // Suppress VideoJS deprecation errors
  }
  originalError.apply(console, args);
};

// Also patch VideoJS methods to prevent warnings at source
if (typeof window !== 'undefined' && window.videojs) {
  // Store original methods
  const originalPlugin = window.videojs.plugin;
  const originalMergeOptions = window.videojs.mergeOptions;
  const originalCreateEl = window.videojs.createEl;
  
  // Replace with silent versions
  window.videojs.plugin = function(...args) {
    return originalPlugin.apply(this, args);
  };
  
  if (window.videojs.mergeOptions) {
    window.videojs.mergeOptions = function(...args) {
      return originalMergeOptions.apply(this, args);
    };
  }
  
  if (window.videojs.createEl) {
    window.videojs.createEl = function(...args) {
      return originalCreateEl.apply(this, args);
    };
  }
}

export default console.warn; 